import React, { useContext } from 'react';
import { Box, Container, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faArrowsDownToPeople,
	faCalendar,
	faCalendarCheck,
	faCalendarXmark,
	faMagnifyingGlassChart,
	faCoins,
	faHandHoldingDollar,
	faMoneyBillTrendUp,
	faScaleBalanced,
	faUserCheck,
	faUsers,
	faWallet,
	faMagnifyingGlassDollar,
	faRoute,
	faSackDollar
} from '@fortawesome/free-solid-svg-icons';
import { PageHeader } from '../../components/base';
import CallerSelector from '../../components/CallerSelector';
import SelectorClientsGestor from './selectores/selectoresCartera/SelectorClientsGestor';
import SelectorCreditsByGestor from './selectores/selectoresCartera/SelectorCreditsByGestor';
import SelectorCobroDiario from './selectores/selectoresCartera/SelectorCobroDiario';
import SelectorRecuperacion from './selectores/selectoresCartera/SelectorRecuperacion';
import SelectorDesembolsos from './selectores/selectoresCartera/SelectorDesembolsos';
import SelectorSaldosCartera from './selectores/selectoresCartera/SelectorSaldosCartera';
import SelectorCreditosVencidos from './selectores/selectoresCartera/SelectorCreditosVencidos';
import SelectorRecuperacionVencidos from './selectores/selectoresCartera/SelectorRecuperacionVencidos';
import SelectorAccountStatus from './selectores/selectoresCartera/SelectorAccountStatus';
import SelectorCreditsCancelled from './selectores/selectoresCartera/SelectorCreditsCancelled';
import SelectorVencimientosProyectados from './selectores/selectoresCartera/SelectorVencimientosProyectados';
import { isAccess } from '../../helpers/Helpers';
import { DataContext } from '../../context/DataContext';
import SelectorSaldosCarteraByGestor from './selectores/selectoresCartera/SelectorSaldosCarteraByGestor';
import SelectorAnalysisWallet from './selectores/selectoresCartera/SelectorAnalysisWallet';
import SelectorBosqueMora from './selectores/selectoresCartera/SelectorBosqueMora';
import SelectorUsertracking from './selectores/selectoresAdministrativos/SelectorUsertracking';

const Reports = () => {
	const { access } = useContext(DataContext);
	return (
		<div>
			<Container maxWidth={false} disableGutters>
				<Box>
					<PageHeader
						titulo="Reportes de Cartera"
						icono={<FontAwesomeIcon icon={faWallet} />}
					/>

					<Grid container spacing={2} justifyContent="center">
						{isAccess(access, 'RCLIENTS') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faUsers}
									text="Reporte de Clientes"
									modalTitle="Reporte de Clientes"
								>
									<SelectorClientsGestor />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCREDXGEST') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faHandHoldingDollar}
									text="Créditos por Gestor"
									modalTitle="Créditos por Gestor"
								>
									<SelectorCreditsByGestor />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCOBDIARIO') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faCalendarCheck}
									text="Cobro Diario"
									modalTitle="Cobro Diario"
								>
									<SelectorCobroDiario />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RECUPERAC') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faUserCheck}
									text="Recuperación"
									modalTitle="Reporte de Recuperacion"
								>
									<SelectorRecuperacion />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RDESEMBOLSO') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faWallet}
									text="Desembolsos"
									modalTitle="Reporte de Desembolsos"
								>
									<SelectorDesembolsos />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RSALCART') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faCoins}
									text="Saldos Cartera"
									modalTitle="Reporte Saldos Cartera"
								>
									<SelectorSaldosCartera />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RSALCART') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faArrowsDownToPeople}
									text="Saldos Cartera por Gestor"
									modalTitle="Reporte Saldos Cartera por Gestor"
								>
									<SelectorSaldosCarteraByGestor />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RSALCART') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faMagnifyingGlassChart}
									text="Analisis de Cartera"
									modalTitle="Reporte Analisis de Cartera"
								>
									<SelectorAnalysisWallet />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCREDVENC') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faCalendarXmark}
									text="Créditos Vencidos"
									modalTitle="Reporte Créditos Vencidos"
								>
									<SelectorCreditosVencidos />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCREDVENC') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faSackDollar}
									text="Recuperación de Vencidos"
									modalTitle="Reporte de Recuperación de Créditos Vencidos"
								>
									<SelectorRecuperacionVencidos />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RVENCPROY') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faCalendar}
									text="Vencimientos Proyectados"
									modalTitle="Reporte Vencimientos proyectados"
								>
									<SelectorVencimientosProyectados />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCREDVENC') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faMagnifyingGlassDollar}
									text="Bosque de Mora"
									modalTitle="Reporte Bosque de Mora"
								>
									<SelectorBosqueMora />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'RCREDCANC') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faMoneyBillTrendUp}
									text="Créditos Cancelados"
									modalTitle="Reporte Créditos Cancelados"
								>
									<SelectorCreditsCancelled />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}
						{isAccess(access, 'RACCOUNTSTS') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faScaleBalanced}
									text="Estado de Cuenta"
									modalTitle="Reporte de Estado de Cuenta"
								>
									<SelectorAccountStatus />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}

						{isAccess(access, 'REP UTRACK') ? (
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<CallerSelector
									icon={faRoute}
									text="Rastreo de Usuarios"
									modalTitle="Reporte Ubicaciones de Usuario"
								>
									<SelectorUsertracking />
								</CallerSelector>
							</Grid>
						) : (
							<></>
						)}
						{/* Cierre de Caja y Estado de Resultado están fuera del menú: al reactivarlos, volver a importar
						    SelectorCierreDiario y SelectorEstadoResultado (W8c quitó los imports sin uso). */}
						{/* 
            {isAccess(access, "RBOXCLOSE") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faCashRegister}
                  text="Cierre de Caja"
                  modalTitle="Reporte de Cierre de Caja"
                >
                  <SelectorCierreDiario />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )} */}

						{/* {isAccess(access, "RRESULTSTS") ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CallerSelector
                  icon={faChartPie}
                  text="Estado de Resultado"
                  modalTitle="Reporte Estado de Resultado"
                >
                  <SelectorEstadoResultado />
                </CallerSelector>
              </Grid>
            ) : (
              <></>
            )} */}
					</Grid>
				</Box>
			</Container>
		</div>
	);
};

export default Reports;
